import './scss/_form-add.scss'
import {FormAddComponent} from './FormAddComponent'

const FormAddPackage = {
    name: 'UIFormAdd',
    configure: function(config) {
        config.addComponent('UIFormAdd', FormAddComponent, false, 'form-add')
    }
}

export {FormAddPackage}
